import * as React from 'react';
import { graphql } from 'gatsby';

import { StoryblokStory } from 'gatsby-source-storyblok';

import Layout from '../components/layout/layout';
import EditorLoader from '../utils/editorLoader';
import { BookingContextProvider } from '../contexts/bookingContext';
import BookingWidget from '../components/booking/widget';
import { titleUtil } from '../utils/title';

const Page = ({ data, pageContext }) => {
  const story = EditorLoader(data);
  const additonalProps = {
    // This is for use in the useGetPageList hook, usePageMenu hook, useBreadcrumbs hook, teaser_listing component, page_menu component and breadcrumbs component:
    currentStoryInternalId: data.storyblokEntry.internalId,
  };

  return (
    <BookingContextProvider
      initSeason={story.content ? story.content.season : story.season}
      initiallyVisible={story.content ? story.content.menu_show_default : false}
    >
      <Layout language={data.storyblokEntry.lang}>
        <StoryblokStory
          story={story}
          bridgeOptions={{ resolveLinks: 'url', preventClicks: true }}
          {...additonalProps}
          breadcrumbs={pageContext.breadcrumb}
        />
        {story.content && story.content.booking_modal_hide !== true && (
          <BookingWidget />
        )}
      </Layout>
    </BookingContextProvider>
  );
};

export default Page;

export const Head = ({ data }) => {

  return (
    <>
      { data.storyblokEntry.field_seo_title_string?.length > 0 ? (
        <title>{titleUtil(data.storyblokEntry.field_seo_title_string)}</title>
      ) : (
        <title>{titleUtil(data.storyblokEntry.field_title_string)}</title>)}
      { data.storyblokEntry.field_seo_exclude_boolean && (
        <meta name="robots" content="noindex" />
      )}
      <title>{titleUtil(data.storyblokEntry.field_seo_title_string || data.storyblokEntry.field_title_string)}</title>
      {data.storyblokEntry.field_seo_exclude_boolean && (
        <meta name="robots" content="noindex" />
      )}
      <meta
        property="og:title"
        content={
          data.storyblokEntry.field_seo_title_string ||
          data.storyblokEntry.field_title_string
        }
      />
      <meta
        name="description"
        content={data.storyblokEntry.field_seo_description_string}
      />

      <meta
        property="og:description"
        content={data.storyblokEntry.field_seo_description_string}
      />
      <meta property="og:type" content="website" />
      {data?.storyblokEntry?.content?.social_image?.filename && (
        <meta
          property="og:image"
          content={data.storyblokEntry.content?.social_image?.filename}
        />
      )}
    </>
  );
};

export const query = graphql`
  query ($full_slug: String!) {
    storyblokEntry(full_slug: { eq: $full_slug }) {
      content
      name
      field_title_string
      field_seo_title_string
      field_seo_exclude_boolean
      field_seo_description_string
      full_slug
      uuid
      id
      internalId
      lang
    }
  }
`;
